import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppTextarea = _resolveComponent("AppTextarea")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    class: "quiz-basic-stage-description",
    title: "How would you introduce yourself to others?",
    description: "Just the highlights, the cliff notes of what makes you, “you”. Personal or professional, what ever you’re happy to share publicly.",
    "is-vertically-aligned": !_ctx.QuizService.editing.value,
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[2] || (_cache[2] = ($event: any) => (_ctx.QuizService.close())),
    prev: !_ctx.QuizService.editing.value
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        onClick: _ctx.navigateNext,
        loading: _ctx.QuizService.isSaving()
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      (!_ctx.QuizService.editing.value)
        ? (_openBlock(), _createBlock(_component_AppInput, {
            key: 0,
            id: "quiz-basic-stage-nickname-input",
            modelValue: _ctx.nickname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nickname) = $event)),
            label: "Nickname",
            type: "text",
            placeholder: "Enter nickname",
            autofocus: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_AppTextarea, {
        id: "quiz-basic-stage-desc-input",
        label: "Description",
        placeholder: "Hi there! My name is Sam.I live with my awesome little fam bam that includes two kids, a loving partner and a pug Chuckles. At work I’m pretty chill..",
        rows: "8",
        modelValue: _ctx.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["is-vertically-aligned", "onQuizNavigation:back", "prev"]))
}